import React, { useState } from "react";
import ReactDOM from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FiLogOut, FiX, FiAlertCircle } from "react-icons/fi";
import "../../styles/logout-modal.css";

const LogoutModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  isLoggingOut,
}) => {
  const [clearSavedIdentity, setClearSavedIdentity] = useState(false);

  if (!isOpen) return null;

  const modalContent = (
    <AnimatePresence>
      <motion.div
        className="logout-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="logout-modal"
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="logout-modal-close"
            onClick={onClose}
            disabled={isLoggingOut}
          >
            <FiX />
          </button>

          <div className="logout-modal-icon">
            <FiLogOut />
          </div>

          <h2>Confirm Logout</h2>

          <p>
            Are you sure you want to logout?
            {userName && <span> Goodbye, {userName}!</span>}
          </p>

          <label style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <input
              type="checkbox"
              checked={clearSavedIdentity}
              onChange={(event) => setClearSavedIdentity(event.target.checked)}
              disabled={isLoggingOut}
            />
            Sign out completely
          </label>

          <div className="logout-modal-actions">
            <button
              className="logout-btn-cancel"
              onClick={onClose}
              disabled={isLoggingOut}
            >
              Cancel
            </button>
            <button
              className="logout-btn-confirm"
              onClick={() => onConfirm(clearSavedIdentity)}
              disabled={isLoggingOut}
            >
              {isLoggingOut ? (
                <span className="logout-spinner" />
              ) : (
                <FiLogOut />
              )}
              {isLoggingOut ? "Signing out..." : "Logout"}
            </button>
          </div>
        </motion.div>

        {isLoggingOut && (
          <div
            className="logout-loading-overlay"
            role="status"
            aria-live="polite"
          >
            <span className="logout-loading-spinner" />
            <span>Signing out...</span>
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default LogoutModal;
